var map = {
	"./22.png": "./src/assets/imgs/22.png",
	"./3233.png": "./src/assets/imgs/3233.png",
	"./ArrowDown.png": "./src/assets/imgs/ArrowDown.png",
	"./Initial/BLogo.png": "./src/assets/imgs/Initial/BLogo.png",
	"./Initial/BannerInitial.jpg": "./src/assets/imgs/Initial/BannerInitial.jpg",
	"./Initial/BannerInitial2.png": "./src/assets/imgs/Initial/BannerInitial2.png",
	"./Initial/BannerInitial5.jpg": "./src/assets/imgs/Initial/BannerInitial5.jpg",
	"./Initial/Ellipse.png": "./src/assets/imgs/Initial/Ellipse.png",
	"./Initial/logoBabitaBShdw.png": "./src/assets/imgs/Initial/logoBabitaBShdw.png",
	"./Initial/logoBabitaWShdw.png": "./src/assets/imgs/Initial/logoBabitaWShdw.png",
	"./LogoRotate.svg": "./src/assets/imgs/LogoRotate.svg",
	"./appleIcon.png": "./src/assets/imgs/appleIcon.png",
	"./bemVindo/BabStoreIcon.webp": "./src/assets/imgs/bemVindo/BabStoreIcon.webp",
	"./bemVindo/emailIcon.png": "./src/assets/imgs/bemVindo/emailIcon.png",
	"./bemVindo/phoneIcon.png": "./src/assets/imgs/bemVindo/phoneIcon.png",
	"./bemVindo/thumbnailHor.png": "./src/assets/imgs/bemVindo/thumbnailHor.png",
	"./bemVindo/thumbnailRet.png": "./src/assets/imgs/bemVindo/thumbnailRet.png",
	"./bemVindo/wpIcon.png": "./src/assets/imgs/bemVindo/wpIcon.png",
	"./beneficio1.png": "./src/assets/imgs/beneficio1.png",
	"./beneficio2.png": "./src/assets/imgs/beneficio2.png",
	"./beneficio3.png": "./src/assets/imgs/beneficio3.png",
	"./beneficio4.png": "./src/assets/imgs/beneficio4.png",
	"./bolsaIcon.png": "./src/assets/imgs/bolsaIcon.png",
	"./calendar.png": "./src/assets/imgs/calendar.png",
	"./circularLogo.png": "./src/assets/imgs/circularLogo.png",
	"./coracao.png": "./src/assets/imgs/coracao.png",
	"./encontraRevendMob.png": "./src/assets/imgs/encontraRevendMob.png",
	"./encontraRevendPc.png": "./src/assets/imgs/encontraRevendPc.png",
	"./face.png": "./src/assets/imgs/face.png",
	"./fashionClub.png": "./src/assets/imgs/fashionClub.png",
	"./fashionStar/LogoFshion.svg": "./src/assets/imgs/fashionStar/LogoFshion.svg",
	"./fashionStar/LogoFshionW.png": "./src/assets/imgs/fashionStar/LogoFshionW.png",
	"./fashionStar/fashionCompLogo.png": "./src/assets/imgs/fashionStar/fashionCompLogo.png",
	"./fashionStar/starExperience.png": "./src/assets/imgs/fashionStar/starExperience.png",
	"./fundoEsq1.jpg": "./src/assets/imgs/fundoEsq1.jpg",
	"./googlePlayIcon.png": "./src/assets/imgs/googlePlayIcon.png",
	"./iconWhatsApp.png": "./src/assets/imgs/iconWhatsApp.png",
	"./insta copy.png": "./src/assets/imgs/insta copy.png",
	"./insta.png": "./src/assets/imgs/insta.png",
	"./logoBabita.png": "./src/assets/imgs/logoBabita.png",
	"./logoBabitaW.png": "./src/assets/imgs/logoBabitaW.png",
	"./logoBabitaW.svg": "./src/assets/imgs/logoBabitaW.svg",
	"./map.png": "./src/assets/imgs/map.png",
	"./menuBtn.png": "./src/assets/imgs/menuBtn.png",
	"./menuLogo.png": "./src/assets/imgs/menuLogo.png",
	"./menuLogoW.png": "./src/assets/imgs/menuLogoW.png",
	"./pagamento.png": "./src/assets/imgs/pagamento.png",
	"./post1.jpg": "./src/assets/imgs/post1.jpg",
	"./post1.png": "./src/assets/imgs/post1.png",
	"./post11.png": "./src/assets/imgs/post11.png",
	"./post2.jpg": "./src/assets/imgs/post2.jpg",
	"./post2.png": "./src/assets/imgs/post2.png",
	"./post3.jpg": "./src/assets/imgs/post3.jpg",
	"./post3.png": "./src/assets/imgs/post3.png",
	"./revendSmile.jpg": "./src/assets/imgs/revendSmile.jpg",
	"./revendSmile.png": "./src/assets/imgs/revendSmile.png",
	"./revendSmileLargeSize.jpg": "./src/assets/imgs/revendSmileLargeSize.jpg",
	"./revendSmileSmallSize.jpg": "./src/assets/imgs/revendSmileSmallSize.jpg",
	"./topLogoRound.svg": "./src/assets/imgs/topLogoRound.svg",
	"./youtube copy.png": "./src/assets/imgs/youtube copy.png",
	"./youtube.png": "./src/assets/imgs/youtube.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs sync recursive ^\\.\\/.*$";